module.exports = __webpack_public_path__ + "static/media/image_14.b0f3698f.png";